module.exports = __webpack_public_path__ + "img/search.be40b95f.svg";